<template>
    <div class="p-1">
        <editor-js
            :data="data.areas[0].content"
            @save="(d) => save(0, d)"
        />
        <div class="video-frame">
            <video-player
                ref="videoPlayer"
                :options="playerOptions"
                v-if="data.video.url"
            />

            <b-button @click="mediaPicker=true"><i class="far fa-film mr-2"></i>Choose Video</b-button>
        </div>
        <editor-js
            :data="data.areas[1].content"
            @save="(d) => save(1, d)"
        />
        <media-picker class="library" type="VIDEO" @choose="chooseMedia" @close="mediaPicker=false" v-if="mediaPicker"></media-picker>
    </div>
</template>

<script>
    import {client as http} from "@/http_client";

    import 'video.js/dist/video-js.css'
    import EditorJs from "../EditorJs.vue";
    import { videoPlayer } from 'vue-video-player'

    import MediaPicker from "../../../cards/media_library/MediaPicker.vue";

    export default {
        components: {videoPlayer, EditorJs, MediaPicker},
        props: ['data'],
        data: function() {
            return {
                mediaPicker: false,

            }
        },
        computed: {
            playerOptions: function() {
                return {
                    // videojs options
                    muted: false,
                    fluid: true,
                    language: 'en',
                    poster: this.data.video.poster,

                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: this.data.video.mime_type,
                        src: this.data.video.url
                    }],
                }
            }
        },
        methods: {
            save(area, data) {
                this.data.areas[area].content = data;
            },
            chooseMedia: function(media) {
                this.mediaPicker = false;

                delete media.updated_at;
                delete media.created_at;
                delete media.org_id;
                this.data.video = media
            }
        },
        created() {
            if (!this.data.areas) {
                this.data.areas = [
                    {areas: 1, content: null, attributes: {}},
                    {areas: 2, content: null, attributes: {}},
                ];
                this.data.video = {
                    poster: '',
                    mime_type: '',
                    url: ''
                }
            }
        }
    };
</script>

<style lang="scss">
    .video-frame {
        border-radius: 5px;
        margin: 0 0 0 1.3rem;
        border: 1px solid #e7e7e7;
        padding: 10px;

    }

    .video-player {
    }

    .library {
        position: fixed;
        top: 10px;
        right: 10px;
        bottom: 10px;
        left: 10px;

        background: white;
        z-index: 2001;
    }
</style>
